module.exports = __webpack_public_path__ + "media/images/bell_black-a343477dba7bce16fa57a34e34ecbae5.svg";